import * as React from 'react';

export interface IOLTAIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * IOLTAIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Interest On Lawyer Trust Account. IOLTA-labeled document with scales-of-justice corner badge.
 */
const IOLTAIcon: React.FunctionComponent<IOLTAIconProps> = ({
  className,
  size = 40,
  title = 'IOLTA (Lawyer Trust Account)',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#0f7e88" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#0f7e88"/>
      <text x="25" y="24" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="9" fontWeight="900" fill="#0f7e88" letterSpacing="0.4">IOLTA</text>
      <line x1="14" y1="29" x2="36" y2="29" stroke="#0f7e88" strokeWidth="0.8"/>
      <line x1="14" y1="32" x2="32" y2="32" stroke="#0f7e88" strokeWidth="0.8"/>
      <circle cx="34" cy="38" r="4.5" fill="#0f7e88"/>
      <line x1="32" y1="36" x2="36" y2="36" stroke="#FFFFFF" strokeWidth="0.5"/>
      <line x1="34" y1="36" x2="34" y2="40" stroke="#FFFFFF" strokeWidth="0.5"/>
      <path d="M32 36 L31 38 L33 38 Z" fill="#FFFFFF"/>
      <path d="M36 36 L35 38 L37 38 Z" fill="#FFFFFF"/>
      <line x1="33" y1="40" x2="35" y2="40" stroke="#FFFFFF" strokeWidth="0.5"/>
  </svg>
);

export default IOLTAIcon;
